import {
    Component,
    MeshComponent,
    Object3D,
    PhysXComponent,
    TextComponent,
} from '@wonderlandengine/api';
import {CursorTarget} from '@wonderlandengine/components';
import {TextFade} from './text-fade.js';
import {delay} from '../utils/delay.js';
import {property} from '@wonderlandengine/api/decorators.js';
import {LevelManagerScene2} from '../scene2/level-manager-scene2.js';

/**
 * investigation-board
 */
export class InvestigationBoard extends Component {
    static TypeName = 'investigation-board';
    /* Properties that are configurable in the editor */

    @property.object()
    levelManager?: Object3D;
    @property.object()
    aboveBoard_text?: Object3D;

    docsFinal_boardText?: Object3D;
    murderImages?: Object3D;
    currentState = '';

    private clicked = 0;
    private levelManagerComponent?: LevelManagerScene2;

    start() {
        /* Add Cursor Functions */
        const target =
            this.object.getComponent(CursorTarget) ||
            this.object.addComponent(CursorTarget)!;
        target.onDown.add(this.onDown.bind(this));

        // target.addUpFunction(this.onUp.bind(this));

        /* Deactive Self */
        const physxComponent = this.object.getComponent(PhysXComponent);
        if (!physxComponent) {
            throw new Error(
                `investigation-board(${this.object.name}): physx component not found`
            );
        }
        physxComponent.active = false; /* Collision */

        if (!this.aboveBoard_text) {
            throw new Error(
                `investigation-board(${this.object.name}): aboveBoard_text not found`
            );
        }

        const textComponent = this.aboveBoard_text.getComponent(TextComponent);
        if (!textComponent) {
            throw new Error(
                `investigation-board(${this.object.name}): text component not found on aboveBoard_text`
            );
        }
        textComponent.active = false;

        /* References */
        if (!this.levelManager) {
            throw new Error(
                `investigation-board(${this.object.name}): levelManager not defined`
            );
        }
        const tempLevelManagerComponent =
            this.levelManager.getComponent(LevelManagerScene2);
        if (!tempLevelManagerComponent) {
            throw new Error(
                `investigation-board(${this.object.name}): levelManagerComponent not found on levelManager`
            );
        }
        this.levelManagerComponent = tempLevelManagerComponent;
        this.docsFinal_boardText = this.levelManagerComponent.docsFinal_boardText;
        this.murderImages = this.levelManagerComponent.murderImages;

        /* General */
        this.currentState = '';
        this.clicked = 0;
    }

    onDown() {
        if (this.currentState == 'collectedAllDocs' && this.clicked == 0) {
            /* Fade-out text */
            this.docsFinal_boardText!.getComponent(TextFade)!.fadeOut();

            delay(0.5)
                .then(() => {
                    /* Wait till fade out */
                    /* Active murderImages */
                    for (const image of this.murderImages!.children) {
                        const childMeshComponent = image.getComponent(MeshComponent);
                        if (!childMeshComponent) {
                            throw new Error(
                                `investigation-board(${this.object.name}): MeshComponent not found on murderImages`
                            );
                        }
                        childMeshComponent.active = true;

                        const childPhysxComponent = image.getComponent(PhysXComponent);
                        if (!childPhysxComponent) {
                            throw new Error(
                                `investigation-board(${this.object.name}): PhysXComponent not found on murderImages`
                            );
                        }
                        childPhysxComponent.active = true; /* Collision */
                    }

                    /* Active Text above board */
                    const textAboveBoard =
                        this.aboveBoard_text!.getComponent(TextComponent);
                    if (!textAboveBoard) {
                        throw new Error(
                            `investigation-board(${this.object.name}): TextComponent not found on aboveBoard_text`
                        );
                    }
                    textAboveBoard.active = true;
                    const fadeAboveBoard = this.aboveBoard_text!.getComponent(TextFade);
                    if (!fadeAboveBoard) {
                        throw new Error(
                            `investigation-board(${this.object.name}): TextFade not found on aboveBoard_text`
                        );
                    }
                    fadeAboveBoard.fadeIn();

                    /* Count Clicks Gate */
                    this.clicked += 1;
                })
                .catch(console.error);
        } else {
            this.levelManagerComponent!.sendMessage('investigationBoardClicked');
        }
    }

    finishPuzzle() {
        const fade = this.aboveBoard_text!.getComponent(TextFade);
        fade?.fadeOut();
    }

    activatePhysx() {
        const physxComponent = this.object.getComponent('physx');
        if (!physxComponent) {
            throw new Error(
                `investigation-board(${this.object.name}): physx component not found`
            );
        }
        physxComponent.active = true; /* Collision */
    }
}
